module.exports = __webpack_public_path__ + "img/icb-leo-Adv-m.60bc481f.png";